module.exports = __webpack_public_path__ + "static/mockup-app-ce5217807795a9e50ca6d466deb57b5f.png";